import VSelectApplyState from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectApplyState', VSelectApplyState),
};
